
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";
import StackedBarChart from "@/components/StackedBarChart/index.vue";
import StackedAreaChart from "@/components/StackedAreaChart/index.vue";
import moment from "moment";
import ActivitySelect from "@/components/ActivitySelect/index.vue";
import { Getter } from "vuex-class";
@Component({
  components: { StackedBarChart, ActivitySelect, StackedAreaChart },
})
export default class RealTimePopularity extends Vue {
  @Prop({ default: () => { } }) RealTimeData: any
  // @Prop({ default: () => { } }) paramsLine: any
  // @Prop({ default: () => { } }) paramsLine1: any
  // @Prop({ default: () => { } }) paramsArea: any
  moneyFormat = moneyFormat;
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  params: Record<string, any> = {};
  
  goDetail() {
    this.$router.push({
        path: '/winningVerifyDetail',
        query: {
          lotteryId: this.RealTimeData.lotteryId
        }
      })
  }
}
